import { render, staticRenderFns } from "./AZCronosInformacao.vue?vue&type=template&id=1bf8a350&scoped=true"
import script from "./AZCronosInformacao.vue?vue&type=script&lang=js"
export * from "./AZCronosInformacao.vue?vue&type=script&lang=js"
import style0 from "./AZCronosInformacao.vue?vue&type=style&index=0&id=1bf8a350&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8a350",
  null
  
)

export default component.exports